import { render, staticRenderFns } from "./BackorderList.vue?vue&type=template&id=1dcebc84&"
import script from "./BackorderList.vue?vue&type=script&lang=js&"
export * from "./BackorderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports